import { type MetaFunction } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { ImageSheet } from '#app/components/image-sheet'
import { Client } from '#app/utils/hubspot.server'

export const meta: MetaFunction = () => [{ title: 'Gallery' }]

export async function loader() {
	if (!process.env.HS_ACCESS_TOKEN) {
		throw new Error('Missing HS_ACCESS_TOKEN environment variable.')
	}
	const HS_ACCESS_TOKEN = process.env.HS_ACCESS_TOKEN
	const hubspotClient = new Client({ accessToken: HS_ACCESS_TOKEN })

	try {
		const result = (
			await hubspotClient.cms.hubdb.rowsApi.getTableRows('gallery')
		).results

		return result
	} catch (e: any) {
		console.error('  > Unable to retrieve rows')
		return e.response.body
	}
}

export default function Index() {
	const data = useLoaderData<typeof loader>()
	return (
		<main className="grid h-full place-items-center font-sans">
			<div className="grid place-items-center px-4 py-16 ">
				<ImageSheet data={data} />
				Gallery
			</div>
		</main>
	)
}
